import { ReactJSXElement } from '@emotion/react/types/jsx-namespace';
import { Box, Drawer, useTheme } from '@mui/material';

type CallbackFunction = (v: boolean) => void;
type LateralDrawerProps = {
  open: boolean;
  setOpen: CallbackFunction;
  position: 'right' | 'left' | 'top' | 'bottom';
  children: ReactJSXElement;
  width?: string;
  size?: 'normal' | 'bigger';
  onClose?: () => void;
};

function LateralDrawer(props: LateralDrawerProps) {
  const theme = useTheme();
  const { open, setOpen, position, children, width, size = 'normal', onClose } = props;
  function getSize() {
    if (width) {
      return width;
    }
    if (size === 'normal') {
      return theme.spacing(60);
    }
    return theme.spacing(75);
  }

  const handleClose = () => {
    if (onClose) {
      onClose();
    }
  };

  return (
    <Drawer
      ModalProps={{
        onBackdropClick: () => {
          setOpen(false);
        },
      }}
      open={open}
      anchor={position}
      onClose={handleClose}
    >
      <Box
        sx={{
          width: getSize(),
          display: 'flex',
          flexDirection: 'column',
          margin: '24px',
          height: 'calc(100vh - 48px)',
          maxHeight: 'calc(100vh - 48px)',
          flexGrow: 1,
        }}
      >
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>{children}</Box>
      </Box>
    </Drawer>
  );
}

export default LateralDrawer;
